










import Vue from "vue";
import Flickity from "vue-flickity";
import { message, QuickReply } from "@/utilities/index";
const QuickReplies = Vue.extend({
  props: ["quickReplies", "messageIndex", "isFullScreen"],
  components: {
    Flickity
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: 0,
        pageDots: false,
        draggable: ">3",
        freeScroll: false,
        cellAlign: "left",
        contain: true,
      },
    };
  },
  methods: {
    sendQuickReply(quickReply: QuickReply) {
      this.$emit("sendQuickReply", quickReply);
    },
    detectLang(title: string) {
      return message.detectLang(title);
    },
  }
});
export default QuickReplies;
